<template>
    <div class="login">
        <div class="d-flex h-100 align-items-center justify-content-center">
            <b-container class="text-center">
                <b-row align-v="center">
                    <b-col cols="12" lg="6">
                        <div class="d-flex align-items-center justify-content-center">
                            <img src="../assets/img/login_logo_demo.svg" class="loginImg" @mousemove="mouseMoveEffect" @mouseout="mouseOutEffect" @mousedown="mouseDownEffect" @mouseup="mouseUpEffect" />
                        </div>
                    </b-col>
                    <b-col cols="12" lg="6" class="text-white h1 mt-4" v-if="this.websiteAvailable == 0">
                        活動已結束
                    </b-col>
                    <b-col cols="12" lg="6" v-if="this.websiteAvailable == 1">
                        <div class="d-flex flex-column align-items-center mx-5">
                            <div class="input-group" style="display:none">
                                <div class="w-100 my-3 text-left" id="username_column">
                                    <label class="text-white w-100" for="username">
                                        <span class="text-alert">*</span>使用者名稱
                                    </label>
                                    <input class="w-100" id="username" maxlength="24">
                                </div>
                                <div class="w-100 mt-3 mb-5 text-left">
                                    <label class="text-white w-100" for="organs">
                                        機關單位
                                    </label>
                                    <input class="w-100" id="organs" maxlength="24">
                                </div>
                            </div>
                            <button v-on:click="login()" class="btn-primary-m">開始存證體驗</button>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>
<script>
import loginLogo from "../assets/img/login_logo_demo.svg";
export default {
    name: "LoginPage",
    methods: {
        mouseMoveEffect(e) {
            const width = e.target.width;
            const height = e.target.height;
            const xVal = e.layerX
            const yVal = e.layerY
            const yRotation = 20 * ((xVal - width / 2) / width)
            const xRotation = -20 * ((yVal - height / 2) / height)
            e.target.style.transform = 'perspective(500px) scale(1.1) rotateX(' + xRotation + 'deg) rotateY(' + yRotation + 'deg)';
        },
        mouseOutEffect(e) {
            e.target.style.transform = 'perspective(500px) scale(1) rotateX(0) rotateY(0)';
        },
        mouseDownEffect(e) {
            e.target.style.transform = 'perspective(500px) scale(0.9) rotateX(0) rotateY(0)';
        },
        mouseUpEffect(e) {
            e.target.style.transform = 'perspective(500px) scale(1.1) rotateX(0) rotateY(0)';
        },
        login() {
            //const username = document.getElementById("username").value;
            //const organs = document.getElementById("organs").value;
            const username = 'demo';
            const organs = '';
            if (!username) {
                if(document.querySelector('#username_column p')){
                    document.querySelector('#username_column p').remove();
                }
                document.querySelector('#username_column').insertAdjacentHTML("beforeend",'<p class="text-alert">使用者名稱為必填</p>');
            } else {
                sessionStorage.setItem('username', username);
                sessionStorage.setItem('organs', organs);
                this.$router.push("/upload");
            }

        }
    },
    data() {
        return {
            loginLogo: loginLogo,
            websiteAvailable: process.env.VUE_APP_WEBSITE_AVAILABLE,
        };
    },
};
</script>
